<div class="email-preview-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span id="dlgCategoryTitle" class="title dialog-title">{{ title }}</span>
      <button
        id="dlgCategoryClose"
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <div
    mat-dialog-content
    class="p-24 pt-8 m-0"
    fxLayout="column"
    fxLayoutAlign="start start"
    fusePerfectScrollbar
  >
    <html-editor
      valueType="html"
      [value]="this.emailTemplate[0]"
      style="height: 100%"
      (change)="onValueChange($event)"
      style="height: 400px;"
    >
    </html-editor>

    <!-- <textarea rows="6" cols="50">{{ this.emailTemplate[0] }}</textarea> -->

    <div mat-dialog-actions class="m-0 p-0 pt-36" fxLayout="row">
      <button
        mat-raised-button
        class="mat-accent"
        [setFocus]="true"
        (click)="sendEmail()"
        [mat-dialog-close]="1"
      >
        SEND EMAIL
      </button>
    </div>
  </div>
</div>
